// import { Button, Form, Input, Space, Table, Drawer } from "antd";
// import { useState } from "react";
// import { EditOutlined, PlusOutlined } from "@ant-design/icons";
// import UploadFoodImage from "../../components/UploadImage";

// interface Props {
//   testimonialsData: any;
//   form: any;
//   isEditing: boolean;
//   setIsEditing: (value: boolean) => void;
//   handleSave: () => void;
//   handleCancel: () => void;
//   loading: boolean;
// }

// const Testimonials = ({
//   testimonialsData,
//   form,
//   isEditing,
//   setIsEditing,
//   handleSave,
//   handleCancel,
//   loading,
// }: Props) => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [testimonialIndex, setTestimonialIndex] = useState<number | null>(null);

//   const testimonials = testimonialsData?.items || [];

//   const openAddDrawer = () => {
//     setTestimonialIndex(null);
//     form.setFieldsValue({
//       testimonialForm: {
//         name: "",
//         location: "",
//         description: "",
//         authorImage: "",
//       },
//     });
//     setDrawerOpen(true);
//   };

//   const openEditDrawer = (record: any, index: number) => {
//     setTestimonialIndex(index);

//     form.setFieldsValue({
//       testimonialForm: record,
//     });

//     setDrawerOpen(true);
//   };

//   const saveTestimonial = () => {
//     const values = form.getFieldValue("testimonialForm");

//     let updatedTestimonials = [...testimonials];

//     if (testimonialIndex !== null) {
//       updatedTestimonials[testimonialIndex] = values;
//     } else {
//       updatedTestimonials.push(values);
//     }

//     form.setFieldsValue({
//       testimonials: {
//         ...testimonialsData,
//         items: updatedTestimonials,
//       },
//     });

//     setDrawerOpen(false);
//   };

//   const columns = [
//     {
//       title: "Image",
//       dataIndex: "authorImage",
//       render: (img: string) => (
//         <img src={img} width={50} height={50} style={{ borderRadius: 50 }} />
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//     },
//     {
//       title: "Location",
//       dataIndex: "location",
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       ellipsis: true,
//     },
//     {
//       title: "Action",
//       render: (_: any, record: any, index: number) => (
//         <EditOutlined onClick={() => openEditDrawer(record, index)} />
//       ),
//     },
//   ];

//   return (
//     <>
//       {/* SECTION HEADING */}
//       <Form.Item label="Heading" name={["testimonials", "heading"]}>
//         <Input disabled={!isEditing} />
//       </Form.Item>

//       <Form.Item label="Description" name={["testimonials", "description"]}>
//         <Input.TextArea rows={3} disabled={!isEditing} />
//       </Form.Item>

//       <Space style={{ marginBottom: 16 }}>
//         <Button
//           type="primary"
//           icon={<PlusOutlined />}
//           onClick={openAddDrawer}
//           disabled={!isEditing}
//         >
//           Add Testimonial
//         </Button>
//       </Space>

//       {/* TABLE */}
//       <Table
//         dataSource={testimonials}
//         columns={columns}
//         pagination={false}
//         rowKey={(record, index) => String(index)}
//       />

//       {/* ADD / EDIT DRAWER */}
//       <Drawer
//         title="Add Testimonial"
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         width={400}
//       >
//         <Form layout="vertical">

//           <Form.Item label="Author Image" name={["testimonialForm", "authorImage"]}>
//             <UploadFoodImage />
//           </Form.Item>

//           <Form.Item label="Name" name={["testimonialForm", "name"]}>
//             <Input />
//           </Form.Item>

//           <Form.Item label="Location" name={["testimonialForm", "location"]}>
//             <Input />
//           </Form.Item>

//           <Form.Item label="Description" name={["testimonialForm", "description"]}>
//             <Input.TextArea rows={4} />
//           </Form.Item>

//           <Space>
//             <Button onClick={() => setDrawerOpen(false)}>Cancel</Button>
//             <Button type="primary" onClick={saveTestimonial}>
//               Save
//             </Button>
//           </Space>

//         </Form>
//       </Drawer>
//     </>
//   );
// };

// export default Testimonials;



import React, { useEffect } from "react";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Form, Input, Button , Image, Rate, Popconfirm} from "antd";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

interface TestimonialsProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  onDeleteReview: (index: number) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  testimonialsData?: any;
  loading?: boolean;
  reviewMode: "list" | "add" | "edit";
  setReviewMode: (value: "list" | "add" | "edit") => void;
  editingReviewIndex: number | null;
  setEditingReviewIndex: (value: number | null) => void;
}

const Testimonials: React.FC<TestimonialsProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  testimonialsData,
  loading,
  reviewMode,
  setReviewMode,
  editingReviewIndex,
  setEditingReviewIndex,
  onDeleteReview,
}) => {
  useEffect(() => {
    if (testimonialsData) {
      form.setFieldsValue({
        testimonials: {
          heading: testimonialsData?.heading || "",
          description: testimonialsData?.description || "",
        },
      });
    }
  }, [testimonialsData]);

  useEffect(() => {
    if (reviewMode === "edit" && editingReviewIndex !== null) {
      const review = testimonialsData?.users[editingReviewIndex];
      form.setFieldsValue({ review });
    }
    if (reviewMode === "add") {
      form.setFieldsValue({
        review: { name: "", location: "", description: "", authorImage: "" },
      });
    }
  }, [reviewMode, editingReviewIndex]);

 return (
  <div>
    {isEditing && (
      <div className="bg-[#F9F9F9] p-5 rounded-xl mb-4">
        <Form layout="vertical" form={form}>
          <Form.Item
            label="Heading"
            name={["testimonials", "heading"]}
            rules={[{ required: true, message: "Enter heading" }]}
          >
            <Input placeholder="Heading" />
          </Form.Item>

          <Form.Item
            label="Description"
            name={["testimonials", "description"]}
            rules={[{ required: true, message: "Enter description" }]}
          >
            <Input placeholder="Description" />
          </Form.Item>
        </Form>

        <div className="flex gap-3 mt-4">
          <ButtonWrapper type="primary" onClick={handleSave} loading={loading}>
            Save
          </ButtonWrapper>

          <ButtonWrapper
            onClick={() => {
              setIsEditing(false);
              handleCancel();
            }}
          >
            Cancel
          </ButtonWrapper>
        </div>
      </div>
    )}


    {reviewMode === "list" && !isEditing && (
      <div className="block sm:hidden mb-4">
        <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-4">
          <div>
            <span className="font-semibold text-primary block mb-1">
              Heading:
            </span>
            <p>{testimonialsData?.heading || "—"}</p>
          </div>

          <div>
            <span className="font-semibold text-primary block mb-1">
              Description:
            </span>
            <p>{testimonialsData?.description || "—"}</p>
          </div>

          <div>
            <span className="font-semibold text-primary block mb-1">
              Action:
            </span>
            <EditOutlined
              onClick={() => setIsEditing(true)}
              className="cursor-pointer text-black text-[18px]"
            />
          </div>
        </div>

        <Button
          type="primary"
          className="mt-3"
          icon={<PlusOutlined />}
          onClick={() => {
            setReviewMode("add");
            setEditingReviewIndex(null);
          }}
        >
          Add Review
        </Button>
      </div>
    )}


    {reviewMode === "list" && !isEditing && (
      <div className="rounded-[20px] overflow-hidden hidden sm:block">
        <table className="min-w-full">
          <thead>
            <tr className="bg-primary text-white">
              <th className="py-3 px-4 text-left">Heading</th>
              <th className="py-3 px-4 text-left">Description</th>
              <th className="py-3 px-4 text-right">Action</th>
            </tr>
          </thead>

          <tbody className="bg-[#F9F9F9]">
            <tr className="border-b">
              <td className="px-4 py-3">{testimonialsData?.heading}</td>
              <td className="px-4 py-3">{testimonialsData?.description}</td>
              <td className="px-4 py-3 text-right">
                <EditOutlined
                  className="text-primary text-xl cursor-pointer"
                  onClick={() => setIsEditing(true)}
                />
              </td>
            </tr>

            <tr>
              <td colSpan={3} className="px-4 py-3 text-right">
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setReviewMode("add");
                    setEditingReviewIndex(null);
                  }}
                >
                  Add Review
                </Button>
              </td>
            </tr>

            <tr>
              <td colSpan={3} className="p-4">
                <p className="font-semibold mb-3">Reviews</p>

                {testimonialsData?.users?.map((users: any, index: any) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-3 rounded mb-2"
                  >
                    <div className="w-1/4 flex items-center gap-5">
                      <Image src={users?.authorImage} alt="" width={60} />
                      <span>{users?.name}</span>
                    </div>
                    
                    <div className="w-1/4 text-gray-600">{users?.location}</div>

                    <div className="w-1/2 text-gray-600 line-clamp-1">
                      {users?.description}
                    </div>

                    <div className="flex gap-4 text-primary text-xl">
                      <EditOutlined
                        className="cursor-pointer"
                        onClick={() => {
                          setReviewMode("edit");
                          setEditingReviewIndex(index);
                        }}
                      />
                      <Popconfirm
                        title="Delete this review?"
                        onConfirm={() => onDeleteReview(index)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <DeleteOutlined className="cursor-pointer text-red-500" />
                      </Popconfirm>
                    </div>
                  </div>
                ))}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )}


    {reviewMode === "list" && !isEditing && (
      <div className="sm:hidden mt-4 space-y-4">
        {testimonialsData?.users?.map((users: any, index: any) => (
          <div
            key={index}
            className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm"
          >
            <div className="flex items-center gap-4 mb-2">
              <Image src={users?.authorImage} width={60} />
              <div>
                <p className="font-semibold">{users?.name}</p>
                <p className="text-gray-500 text-sm">{users?.location}</p>
              </div>
            </div>

            <p className="text-gray-600 mb-2">{users?.description}</p>

            <div className="flex justify-end gap-4 text-primary text-xl mt-3">
              <EditOutlined
                className="cursor-pointer"
                onClick={() => {
                  setReviewMode("edit");
                  setEditingReviewIndex(index);
                }}
              />
              <Popconfirm
                title="Are you sure to delete this review?"
                onConfirm={() => onDeleteReview(index)}
                okText="Yes"
                cancelText="No"
                
              >
                <DeleteOutlined className="cursor-pointer text-red-500" />
              </Popconfirm>
            </div>
          </div>
        ))}
      </div>
    )}

   {reviewMode !== "list" && !isEditing && (
        <div className="bg-[#F9F9F9] p-5 rounded-xl">
          <Form layout="vertical" form={form}>
            <Form.Item
              label="Name"
              name={["review", "name"]}
              rules={[{ required: true, message: "Enter name" }]}
            >
              <Input placeholder="Reviewer Name" />
            </Form.Item>
            
            <Form.Item
              label="Location"
              name={["review", "location"]}
              rules={[{ required: true, message: "Enter location" }]}
            >
              <Input placeholder="Reviewer Location" />
            </Form.Item>

            <Form.Item
              label="Description"
              name={["review", "description"]}
              rules={[{ required: true, message: "Enter description" }]}
            >
              <TextArea rows={3} placeholder="Review Description" />
            </Form.Item>

           
             <Form.Item
                label="authorImage"
                name={["review", "authorImage"]}
                rules={[
                  { required: true, message: "Please upload a image" },
                ]}
              >
                <UploadFoodImage maxUploadCount={1} bannerAspect={1} />
              </Form.Item>
          </Form>

          <div className="flex gap-3 mt-5">
            <ButtonWrapper type="primary" onClick={handleSave} loading={loading}>
              Save
            </ButtonWrapper>

            <ButtonWrapper
              onClick={() => {
                handleCancel();
                setReviewMode("list");
                setEditingReviewIndex(null);
              }}
            >
              Cancel
            </ButtonWrapper>
          </div>
        </div>
      )}
  </div>
);

};

export default Testimonials;
